module.exports = __webpack_public_path__ + "static/media/taco_stand_menu_illustration_2017.4b7b38c1.webp";